import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

const PRODUCT_IMAGE_SIZE = 40;

export const StyledProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;

  .product-img {
    min-width: ${PRODUCT_IMAGE_SIZE}px;
    max-height: ${PRODUCT_IMAGE_SIZE}px;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .product-img {
    max-height: 32px;
    min-width: 32px;

    img {
      height: 32px;
      width: 32px;
    }
  }

  .tooltip-container {
    height: 100%;
  }

  .tooltip-icon {
    height: 14px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    margin-left: 2px;
    margin-right: 4px;
  }

  .html-tooltip {
    display: flex;
    align-items: center;
  }
` as any;

export const StyledTextContainer = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color: #fff;
  font-size: 11px;
  max-width: calc(100% - 70px);

  .quantity {
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: white;

    @media (min-width: ${breakpoints.mobileL}) {
      font-size: 14px;
    }
  }

  .stroked {
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration: line-through;
  }

  .product-rarity {
    display: flex;
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 400;

    .product-rarity-stars {
      margin-left: 3px;
      display: flex;
      align-items: center;

      img {
        height: 8px;
      }
    }
  }
`;
